import React, { useRef, useState } from 'react';
import {
  Box,
  Button,
  Grid,
  Typography,
} from '@mui/material';
import {
  SimpleDialog,
  TableComponents,
  InputV2,
  ConfirmDialog,
  ButtonLoading,
  SelectV,
  FilterPod,
  Icons
} from 'components';
import useCustomHook from './hooks';
import { validator } from 'myValidation';
import createToast from 'components/Toast/Toast';
import { useLocation } from 'react-router-dom';
import { columns, generateData } from './Columns';
import { toFilterVOS, filterVOStoQueryStr } from 'components/FilterPod';
import CardsServices from '../../services';
import { useStyles } from './style';
import { FormProvider, useForm } from 'react-hook-form';
import FilterButton from 'components/FilterPod/FilterButton';
import { getDynamicObjectAction } from 'utility';
import axios from 'axios';

// TODO: add auto validation (rules) for contacts
const ContactList = (props) => {
  const classes = useStyles();
  const {
    isLoading,
    setIsLoading,
    list,
    setList,
    isSubmitting,
    setIsSubmitting,
    setFilterParams,
    size,
    setSize,
    filters,
    setFilters,
    isNewDialogOpen,
    setIsNewDialogOpen,
    confirmDeleteModal,
    setConfirmDeleteModal,
    itemIdToDelete,
    setItemIdToDelete,
    currentId,
    setCurrentId,
    page,
    setPage,
    grantUserDataType,
    setGrantUserDataType,
    firstName, setFirstName,
    lastName, setLastName,
    userContactInfo, setUserContactInfo
  } = useCustomHook();

  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);
  const currentLoaction = useLocation();

  const grantTypeOptions = [
    {
      value: 'cellphoneNumber',
      label: 'تلفن همراه',
      rules: ['isMobile'],
      englishNumber: true,
    },
    {
      value: 'username',
      label: 'نام کاربری',
      rules: ['isUsername'],
      englishNumber: true,
    },
    {
      value: 'email',
      label: 'پست الکترونیک',
      rules: ['isEmail'],
      englishNumber: true,
    },
  ];

  const types = {
    cellphoneNumber: 'cellphoneNumber',
    username: 'username',
    email: 'email',
  };

  let tableRef = useRef();
  const methods = useForm();
  const { control, register, formState: { errors } } = methods;
  // -- HOOKS --//
  let actionsList = getDynamicObjectAction([
    'contactsNewCardPage',
    'contactsImprestNewCardPage',
    'contactsDeleteCardPage',
    'contactsImprestDeleteCardPage',
    'contactsUpdateCardPage',
    'contactsImprestUpdateCardPage'
  ]);
  const getItems = async (query) => {
    try {
      setIsLoading(true);
      let filter = toFilterVOS([...filters]);
      let queries = filterVOStoQueryStr(filter);
      setPage(query?.page);
      let params = {
        offset: query ? query?.pageNumber * query?.pageSize : page * size,
        size: query ? query?.pageSize : size,
        ...queries,
      };
      const data = {
        filterVOS: [],
        parentParams: [],
        orderByElementVOS: [],
      };

      setFilterParams({ data, params });

      const res = await CardsServices.getContact(params);

      let list = [];

      list = generateData(res?.result, {
        page: query ? query?.pageNumber : page,
        pageSize: query?.pageSize || size,
      });
      setIsLoading(false);
      const da = res?.result;
      setList(da);

      let d = {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: res?.count,
      };
      return d; //passed to MaterialTable
    } catch (error) {
      if (axios.isCancel(error)) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };

  const postItem = async () => {

    const values = methods.getValues();
    if (!firstName) {
      createToast('خطا', ' نام مخاطب را وارد نمایید.', 'danger');
      return;
    }
    if (!lastName) {
      createToast('خطا', ' نام خانوادگی مخاطب را وارد نمایید .', 'danger');
      return;
    }
    if (!userContactInfo) {
      createToast('خطا', `${grantTypeOptions.find((v) => v?.value === grantUserDataType)?.label} مخاطب را وارد نمایید.`, 'danger');
      return;
    }
    if (!String(values.contact).trim()) {
      return;
    }

    try {
      let obj = {};
      const values = methods.getValues();
      if (!String(values.contact).trim()) {
        return;
      }

      if (grantUserDataType == 'cellphoneNumber') {
        if (
          String(values.contact).trim().length > 10 &&
          String(values.contact).trim()[0] == '0' &&
          String(values.contact).trim()[1] == '9'
        ) {
          const v = validator.matches(
            String(values.contact).trim() ?? '',
            /^((?:\+98|0)(\d){2}(\d){8})$/,
          );

          if (!v) {
            createToast('خطا', `تلفن همراه به درستی وارد نشده است .`, 'danger');
            return;
          }
        } else {
          createToast('خطا', `تلفن همراه به درستی وارد نشده است .`, 'danger');
          return;
        }
      }
      if (grantUserDataType == 'email') {
        const v = validator.isEmail(String(values.contact).trim() ?? '', /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,);
        if (!v) {
          createToast('خطا', `پست الکترونیک بدرستی وارد نشده است.`, 'danger');
          return;
        }
      }
      if (grantUserDataType == 'username') {
        const v = validator.matches(
          String(values.contact).trim() ?? '',
          /^[^[\u0600-\u06FF\s]*$/,
        );
        if (!v) {
          createToast('خطا', `نام کاربری باید انگلیسی وارد شود. `, 'danger');
          return;

        }
      }

      obj[types[grantUserDataType]] = [String(values.contact).trim()];
      setIsSubmitting(true);
      const body = {
        firstName: [firstName],
        lastName: [lastName],
        ...obj
      };
      const result = await CardsServices.addContact(body);
      handleCloseNew();
      createToast('موفق', 'مخاطب با موفقیت اضافه شد.', 'success');
      setIsSubmitting(false);
      setPage(0)
      setSize(10)
      setTimeout(() => {
        tableRef?.current?.onChangeTable();
      }, 100)
    } catch (error) {
      setIsSubmitting(false);
    }
  };

  const putItem = async () => {
    try {
      let obj = {};
      if (!firstName) {
        createToast('خطا', ' نام  را وارد کنید.', 'danger');
        return;
      }
      if (!lastName) {
        createToast('خطا', ' نام خانوادگی  را وارد کنید.', 'danger');
        return;
      }
      if (!userContactInfo) {
        createToast('خطا', `${grantTypeOptions.find((v) => v?.value === grantUserDataType)?.label} را وارد کنید.`, 'danger');
        return;
      }

      setIsSubmitting(true);
      obj[types[grantUserDataType]] = [userContactInfo];
      const body = {
        firstName: [firstName],
        lastName: [lastName],
        ...obj
      };
      const result = await CardsServices.putContact(currentId, body);
      createToast('موفق', 'اطلاعات مخاطب با موفقیت بروزرسانی شد.', 'success');
      handleCloseNew();
      setIsSubmitting(false);
      setPage(0)
      setSize(10)
      setTimeout(() => {
        tableRef?.current?.onChangeTable();
      }, 100)
    } catch (error) {
      setIsSubmitting(false);
    }
  };

  const deleteItem = async () => {
    setIsSubmitting(true);
    if (!itemIdToDelete) return;
    try {
      const result = await CardsServices.deleteContact(itemIdToDelete);
      setItemIdToDelete(null);
      setConfirmDeleteModal(false);
      createToast('موفق', 'مخاطب با موفقیت حذف شد.', 'success');
      setIsSubmitting(false);
      setPage(0)
      setSize(10)
      setTimeout(() => {
        tableRef?.current?.onChangeTable();
      }, 100)
    } catch (error) {
      setIsSubmitting(false);
    }
  };

  // -- OTHER FUNCTIONS --//
  const handleCloseNew = () => {
    setIsNewDialogOpen(false);
    setFirstName('');
    setUserContactInfo('')
    setLastName('');
  };

  const handleNew = () => {
    setIsNewDialogOpen(true);
    setFirstName('');
    setUserContactInfo('')
    setLastName('');
    setCurrentId('');
  };

  const handleOnEdit = (item) => {
    setCurrentId(item?.id);
    setFirstName(item?.firstName);
    setLastName(item?.lastName);
    if (item.cellphoneNumber) {
      setUserContactInfo(item.cellphoneNumber)
      setGrantUserDataType('cellphoneNumber')
    }
    else if (item.email) {
      setUserContactInfo(item.email);
      setGrantUserDataType('email')

    }
    else if (item.username) {
      setUserContactInfo(item.username);
      setGrantUserDataType('username')

    }


    setIsNewDialogOpen(true);
  };

  const onFiltersChange = (newFilters) => {
    setFilters(newFilters);
    setPage(0)
    setSize(10)
    setTimeout(() => {
      tableRef?.current?.onChangeTable(true);
    }, 100)
  };
  return (
    <div>
      <SimpleDialog
        title={`${currentId ? "ویرایش مخاطب" : "تعریف مخاطب جدید"}`}
        open={isNewDialogOpen}
        icon={<Icons icon='userPlus' color='#2B3990' size='24' />}
        onClose={handleCloseNew}
        actions={
          <>
            <ButtonLoading
              name={`ثبت و ${currentId ? 'تایید' : 'افزودن مخاطب'}`}
              loading={isSubmitting}
              variant="contained"
              color="primary"
              startIcon={<Icons icon='plusCircle' color="#fff" size="18" />}
              onClick={currentId ? putItem : postItem}
            />
            <Button variant="contained" onClick={handleCloseNew}>
              انصراف
            </Button>
          </>
        }
      >
        <Typography className={classes.newItemHint}>
        </Typography>
        <FormProvider {...methods}>
          <form
            className={classes.form}
            autoComplete="off"
          >
            <Grid container spacing={2} xs={12}>
              <Grid item xs={12} md={6}>
                <SelectV
                  name="type"
                  options={grantTypeOptions}
                  label="نوع اطلاعات مخاطب"
                  control={control}
                  register={register}
                  rules={['required']}
                  required
                  onChangeFunc={(k, e) => {
                    setGrantUserDataType(e?.target?.value);
                  }}
                  defaultValue={grantUserDataType}
                  errors={errors}
                  disabled={currentId}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <InputV2
                  control={control}
                  register={register}
                  errors={errors}
                  rules={[
                    'required',
                    ...grantTypeOptions.find((v) => v?.value === grantUserDataType)?.rules,
                  ]}
                  englishNumber={
                    grantTypeOptions.find((v) => v?.value === grantUserDataType)?.englishNumber
                  }
                  name="contact"
                  label={grantTypeOptions.find((v) => v?.value === grantUserDataType)?.label}
                  mainStyle={{ width: '100%', marginLeft: 0, marginRight: 0 }}
                  fullWidth
                  dir="ltr"
                  placeholder=""
                  defaultValue={userContactInfo ?? ''}
                  disabled={currentId}
                  onChangeValue={(e) => {
                    setUserContactInfo(e.target.value);
                  }}

                />
              </Grid>
              <Grid item xs={12} md={6}>
                <InputV2
                  control={control}
                  register={register}
                  errors={errors}
                  name="firstName"
                  label="نام"
                  defaultValue={firstName}
                  mainStyle={{ width: '100%', marginLeft: 0, marginRight: 0 }}
                  fullWidth
                  onChangeValue={(e) => setFirstName(e?.target?.value)}
                  placeholder=""
                  rules={['required']}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <InputV2
                  label="نام خانوادگی"
                  errors={errors}
                  name="lastName"
                  control={control}
                  register={register}
                  defaultValue={lastName}
                  onChangeValue={(e) => setLastName(e?.target?.value)}
                  mainStyle={{ width: '100%', marginLeft: 0, marginRight: 0 }}
                  fullWidth
                  placeholder=""
                  rules={['required']}
                />
              </Grid>
            </Grid>
          </form>
        </FormProvider>
      </SimpleDialog>

      <Grid item xs={12}>
        <Box display="flex" justifyContent='end' alignItems="flex-end" style={{ marginBottom: 16 }}>
          <FilterButton
            setOpenFilterDialog={setOpenFilterDialog}
            filters={filters}
          />
          {(String(currentLoaction?.pathname).toUpperCase().includes('IMPREST') ? actionsList['contactsImprestNewCardPage'] : actionsList['contactsNewCardPage']) && (
            <Button
              onClick={() => handleNew()}
              color="primary"
              variant="contained"
              startIcon={<Icons icon='plusCircle' color='#fff' size='18' />}

            >
              افزودن مخاطب جدید
            </Button>
          )}
        </Box>
        <Box>
          <FilterPod
            filters={filters}
            onChange={onFiltersChange}
            openFilterDialog={openFilterDialog}
            setOpenFilterDialog={setOpenFilterDialog}
            handleCloseFilterDialog={handleCloseFilterDialog}
          />
        </Box>
      </Grid>
      <TableComponents
        data={getItems}
        columns={columns(actionsList, currentLoaction, handleOnEdit, setItemIdToDelete, setConfirmDeleteModal)}
        isLoading={isLoading}
        ref={tableRef}
        onChange={(ps) => {
          setPage(ps?.pageNumber)
          setSize(ps?.pageSize)
          return getItems(ps)
        }}
      />

      <ConfirmDialog
        open={confirmDeleteModal}
        onClose={() => setConfirmDeleteModal(false)}
        onConfirm={deleteItem}
        title="تایید حذف مخاطب"
        content="آیا از حذف مخاطب انتخاب شده اطمینان دارید؟"
        confirmButtonText="حذف مخاطب"
        loading={isSubmitting}
        cancelButtonProps="انصراف"
      />
    </div>
  );
};

export default ContactList;
